import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import logo from '../../assets/keytruda-logo.svg';
import QsubLogo from "../../assets/keytruda-qlex-logo.svg";
import MainMenuLarge from './MainMenuLarge';
import MainMenuSmall from './MainMenuSmall';
import CustomizeFilter from '../CustomizeFilter';
import MenuLaunchButton from './MenuLaunchButton';
import Media from 'react-media';
import Link from 'gatsby-link';
import * as colors from '../../util/colors';
import { useDispatch, useSelector } from 'react-redux';
import { useShallowEqualSelector } from '../../util/hooks';
import useKeydownHandler from '../../util/accessibility/useKeydownHandler';
import useOnClickOutside from 'use-onclickoutside';
import {
    openOverlay,
    closeOverlay,
    openMobileMenu,
    closeAllMenuItems,
    openMenuItem,
    closeMobileMenu,
    preventScrolling,
    allowScrolling,
} from '../../store/actions';
import {
    NAV_OVERLAY_KEY,
    MobileNavOverlay,
    DesktopNavInnerFilterOverlay,
} from '../../layouts/NavContainer';
import { NAVIGATION_BREAKPOINT, NAVIGATION_BREAKPOINT_UNITLESS } from '../../constants/layout';
import { FilterContext } from '../FilterProvider';
import QSubNotificationBanner from './QSubNotificationBanner';
import { useLocation } from '@reach/router';

const bp = NAVIGATION_BREAKPOINT_UNITLESS;

const navItemsData = [
    {
        label: 'Efficacy',
        activePath: '/efficacy/',
        url: '/efficacy/',
    },
    {
        label: 'Safety',
        activePath: '/safety/',
        children: [
            {
                label: 'Selected Adverse Reactions',
                url: '/safety/adverse-reactions/',
            },
            {
                label: 'Treatment Monitoring & Management',
                url: '/safety/monitoring-managing-adverse-reactions/',
            },
        ],
    },
    {
        label: 'Biomarker Testing',
        activePath: '/biomarker-testing/',
        children: [
            {
                label: 'Biomarker Overview',
                url: '/biomarker-testing/biomarker-overview/',
            },
            {
                label: 'PD&#8288;-&#8288;L1 Testing & Scoring',
                url: '/biomarker-testing/pd-l1/',
            },
            {
                label: 'MSI/MMR Testing',
                url: '/biomarker-testing/msi-mmr/',
            },
        ],
    },
    {
        label: 'Dosing & <br/>Preparation',
        activePath: '/dosing/',
        children: [
            {
                label: 'Dosing',
                url: '/dosing/options/',
            },
            {
                label: 'Preparation, Storage & Administration',
                url: '/dosing/preparation-storage-administration/',
            },
            {
                label: 'Dose Modifications',
                url: '/dosing/dose-modifications/',
            },
        ],
    },
    {
        label: 'Resources',
        activePath: '/resources/',
        children: [
            {
                label: 'Resource Center',
                url: '/resources/hcp-and-patient-resources/',
            },
            {
                label: 'Patient Support Program',
                url: '/resources/key-you-patient-support-program/',
            },
            {
                label: 'Mechanism of Action',
                url: '/resources/mechanism-of-action/',
            },
        ],
    },

];

const QsubNavItemData = [
    {
        label: 'MK-3475A-D77 Study Design',
        activePath: '#mk-3475a-d77-study-design',
        url: '#mk-3475a-d77-study-design',
    },
    {
        label: 'Results',
        activePath: '#results',
        url: '#results',
    },
    {
        label: 'Safety Profile',
        activePath: '#safety-profile',
        url: '#safety-profile',
    },
    {
        label: 'Dosing & Preparation',
        activePath: '#dosing-preparation',
        // url: '#dosing-preparation',
        children: [
            {
                label: 'KEYTRUDA QLEX: Dosing Options',
                url: '#keytruda-qlex-dosing-options',
            },
            {
                label: 'Preparation of the Syringe',
                url: '#preparation-of-the-syringe',
            },
            {
                label: 'Storing the Prepared Syringe',
                url: '#storing-the-prepared-syringe',
            },
            {
                label: 'Storing the Vials',
                url: '#storing-the-vials',
            },
            {
                label: 'Indication-Specific Dosing Information',
                url: '#indication-specific-dosing-information',
            },
        ],
    },
]

// These are shared locally, and only matter for local components. No need to share outside this component.
const nav_bottom_border_size = '3px';
const inner_flex_nav_z_index = 3;
const StyledNav = styled.nav`
    width: 100%;
    background: ${colors.white};
    position: sticky;
    border-bottom: ${nav_bottom_border_size} solid ${colors.silver};
    transition: border-color 0.3s ease-in-out;
    z-index: 0;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);

    ${({ isOpen }) => isOpen && `border-color: ${colors.keytrudaGreen};`}

    @media (hover:hover) {
        &:hover {
            border-color: ${colors.keytrudaGreen};
        }
    }

    > .inner-flex {
        display: ${props => (props.filterOpen ? 'none' : 'flex')};
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0 0 20px;
        max-width: 1032px;
        margin: 0 auto;

        position: relative;
        background-color: ${colors.white};
        z-index: ${inner_flex_nav_z_index};
    }

    //handling for border when the filter is open
    ${props =>
        props.filterOpen && `border-bottom: ${nav_bottom_border_size} solid ${colors.silver};`}

    @media (max-width: ${NAVIGATION_BREAKPOINT}) {
    > .inner-flex {
        padding: ${props => props.brandType === 'qsub' && '0'};
    }
    
    }
`;

const LogoWrapper = styled.div`
    display:flex;
    padding: 14px 0;

    @media(max-width: ${NAVIGATION_BREAKPOINT}) {
        padding-inline: 10px;
    }
`;

const LogoContainer = styled(Link)`
    padding: ${(props)=> props.brandType === "keytrudahcp" &&  '0 20px 0 0'};
    flex: 2 1 auto;
    display: grid;
    align-items: ${(props)=> props.brandType === "keytrudahcp" &&  'center'};
     > img {
        width: 100%;
        display: block;
    }
    ${(props)=> props.brandType === "keytrudahcp"?
        `
         > img {
            max-width: 160px;
        }
        `:

        `
         &.keytrudaLogo{
         padding:0;
         padding-right:16px;
                > img {
                    width: 120px;
                    height: 39.59px; 
                }
                @media(max-width: ${NAVIGATION_BREAKPOINT}){
                padding-right: 10px;
                   > img { 
                        width: 75px;
                        height: 24px;
                    }
                }
            }

            &.qsub{
            padding-left: 16px;
            border-left: 0.6px solid ${colors.silver};
                > img {
                    width: 229.275px;
                    height: 50.95px;
                }
                @media(max-width: ${NAVIGATION_BREAKPOINT}){
                padding-left: 10px;
                    > img {
                        width: 143.118px;
                        height: 31.804px;
                        flex-shrink: 0;
                    }
                }
            }
            
        `
    }
   
`;

// Position this _outside_ our StyledNav
const CustomizeFilterOutOfDocumentFlow = styled.div`
    position: absolute;
    top: calc(100% + ${nav_bottom_border_size});
    width: 100%;
    z-index: ${inner_flex_nav_z_index - 1};
    display: flex;
    flex-flow: column nowrap;
    overflow: visible;
    //handle drop shadow to avoid it 'overlapping' with Main Nav (above it)
    &:after {
        content: '';
        position: absolute;
        width: 100%;
        bottom: 1px;
        z-index: -1;
        height: 15px;
    }

    @media (max-width: ${bp}px) {
        top: calc(100% + ${props => (props.filterOpen ? '0px' : nav_bottom_border_size)});
    }
`;

const mainNavSelector = state => state.mainNavigation;

const MainNavigation = ({
    main_nav_ref,
    onMainNavRef,
    launch_button_container_ref,
    filter_wrapper_ref,
    general_modal_ref,
    brandType,
    location,
    isNavigation
}) => {
    // @see https://react-redux.js.org/api/hooks#equality-comparisons-and-updates
    const { openItem, mobileMenuOpen } = useShallowEqualSelector(mainNavSelector);
    const filterOpen = useSelector(state => state.filterOpen);
    let scrolled_passed = useSelector(state => state.scrolledPastInPageSSI);
    const [isVisible, setVisible] = useState(true)
    const pageLocation = useLocation();

    const dispatch = useDispatch();

    // Determine whether to render CustomizeFilter by checking if this page has been wrapped with FilterProvider
    const hasFilterContext = useContext(FilterContext) != null;

    const styled_nav_ref = useRef(null);

    /**
     * @param {Number} index The index of the menu item.
     */
    const itemClickHandler = index => {
        if (openItem === index) {
            // Clicked an open menu, close it
            dispatch(closeAllMenuItems(null));
            dispatch(closeOverlay());
            dispatch(allowScrolling());

        } else {
            // Otherwise open the new menu (which will close the currently open one)
            dispatch(openMenuItem(index));
            dispatch(openOverlay(NAV_OVERLAY_KEY));
            dispatch(preventScrolling());
        }
    };

    const mobileMenuLaunchHandler = () => {
        dispatch(openMobileMenu());
        dispatch(openOverlay(NAV_OVERLAY_KEY));
        dispatch(preventScrolling());
        const menu= document.getElementsByTagName('html')[0];
       if(menu){
        setTimeout(()=>{
            menu.style.width='100vw';
        }, 500)   
       }
       
    };

    const closeAllHandler = () => {
        dispatch(closeAllMenuItems());
        dispatch(closeMobileMenu());
        dispatch(closeOverlay());
        dispatch(allowScrolling());
        const menu= document.getElementsByTagName('html')[0];      
        if(menu && menu.style.width){
            menu.style.removeProperty("width");
        }

    };

    // Close everything when we keydown 'Esc'
    useKeydownHandler(closeAllHandler, 'Escape');

    // Close everything when we click outside the main nav
    useOnClickOutside(styled_nav_ref, e => {
        
        /**
         * If we click on the Sticky ISI launch button, bail early.
         */
        if (launch_button_container_ref?.current?.contains(e.target)) {
            return;
        }

        /**
         * Only close everything if something is open.
         * Only works for desktop. To get this working on Mobile, we'd need 2 `useOnClickOutside` calls.
         * Aka, don't fire `closeAllHandler` _every_ time we click outside.
         */
        if (openItem != null && !mobileMenuOpen) {
            closeAllHandler();
        }
    });

    useEffect(() => {
        if(openItem !== null) {
            // console.log('Debugging: ', 'Inicializando', openItem);
            console.log('Debugging: ', 'Submenu', openItem);
        }
    }, [openItem]);

    useEffect(() => {
        if(!isNavigation) return;
        launch_button_container_ref.current.style.transform = (scrolled_passed ? 'translateY(100%)' : 'none');
    }, [scrolled_passed, isNavigation])


    return (
        <>
            <StyledNav isOpen={openItem !== null} filterOpen={filterOpen} ref={main_nav_ref} brandType={brandType} aria-label='Main navigation'>
                <div className="inner-flex" ref={onMainNavRef}>
                   
                    {
                        brandType === "qsub" ?
                    <LogoWrapper>
                        <LogoContainer
                        title="Home"
                        to={isNavigation ? '/' : "#"}
                        onClick={closeAllHandler}
                        data-design-category="top_nav_vd"
                        brandType={brandType}
                        className="keytrudaLogo"
                    >
                        <img src={logo} alt="KEYTRUDA® (pembrolizumab): Website for Health Care Professionals" />
                    </LogoContainer>
                    <LogoContainer
                        title=""
                        to={isNavigation ? "/qlex/" : "#"}
                        onClick={closeAllHandler}
                        data-design-category="top_nav_vd"
                        brandType={brandType}
                        className="qsub"
                    >
                        <img src={QsubLogo} alt="KEYTRUDA QLEX™ (pembrolizumab and berahyaluronidase alfa-pmph) Logo" />
                    </LogoContainer>
                    </LogoWrapper>
                     :
                    <LogoContainer
                        title="Home"
                        to="/"
                        onClick={closeAllHandler}
                        data-design-category="top_nav_vd"
                        brandType={brandType}
                        className="keytrudaLogo"
                    >
                        <img src={logo} alt="KEYTRUDA® (pembrolizumab): Website for Health Care Professionals" />
                    </LogoContainer>
                    }

                    {/*  Mobile-only */}
                    {
                        isNavigation ? <MenuLaunchButton clickHandler={mobileMenuLaunchHandler} /> : null }

                    {/* for SEO scanability, the MainMenuLarge is always in the DOM */}
                    {
                        isNavigation ? <MainMenuLarge
                        styled_nav_ref={styled_nav_ref}
                        clickHandler={itemClickHandler}
                        items={brandType === "keytrudahcp" ? navItemsData : QsubNavItemData}
                        openItem={openItem}
                        closeAllHandler={closeAllHandler}
                        brandType={brandType}
                    /> : null
                    }
                    
                </div>
                    {
                        isNavigation ?
                <CustomizeFilterOutOfDocumentFlow filterOpen={filterOpen}>
                    <DesktopNavInnerFilterOverlay />
                    {hasFilterContext &&
                        <CustomizeFilter
                            filter_wrapper_ref={filter_wrapper_ref}
                        />
                    }
                </CustomizeFilterOutOfDocumentFlow> : null }
            </StyledNav>
           {/* {isVisible && <QSubNotificationBanner /> } */}
            {/*
                Importantly this overlay lives between the <StyledNav /> and
                the <MainMenuSmall /> so that the overlay can sit _above_ the
                <StyledNav /> while also sitting _below_ the <MainMenuSmall />
            */}
            {
                isNavigation ? 
                
                <><MobileNavOverlay brandType={brandType}/> 


            <Media query={{ maxWidth: bp }}>
                {matches => {
                    if (!matches) {
                        if (mobileMenuOpen) {
                            /**
                             * If we had the mobile menu open, and resized to desktop,
                             * then close those mobile menu.
                             *
                             * We can maybe be more surgical here, but the nav seems buggy
                             * if a subnav is open and you resize larger: you'd think the desktop
                             * nav would render open, but it kind of half renders? Not sure where
                             * the bug is, but this is such an edge case its OK to just close everything.
                             */
                            closeAllHandler();
                        }
                        return null;
                    }

                    // Otherwise, our media query matches, render the mobile menu
                    return (
                        
                        <MainMenuSmall
                            closeAllHandler={closeAllHandler}
                            isOpen={mobileMenuOpen}
                            itemClickHandler={itemClickHandler}
                            items={brandType === "keytrudahcp" ? navItemsData : QsubNavItemData}
                            openItem={openItem}
                            general_modal_ref={general_modal_ref}
                            brandType={brandType}
                        />
                    );
                }}
            </Media></> : null }
        </>
    );
};

export default MainNavigation;
